export default "__VITE_ASSET__Bcp88G_g__"